import type { KioskStepKey } from "./computeKioskSteps";

export function reconcileStepIndex(
  previousIndex: number,
  previousStepKeys: readonly KioskStepKey[],
  nextStepKeys: readonly KioskStepKey[]
): number {
  if (nextStepKeys.length === 0) return 0;

  const lastIndex = nextStepKeys.length - 1;
  const previousKey = previousStepKeys[previousIndex];

  if (previousKey === undefined) {
    return Math.min(Math.max(previousIndex, 0), lastIndex);
  }

  const sameStepInNewFlow = nextStepKeys.indexOf(previousKey);
  if (sameStepInNewFlow !== -1) return sameStepInNewFlow;

  const stepWasWithdrawn = previousStepKeys
    .slice(0, previousIndex)
    .reverse()
    .map((key) => nextStepKeys.indexOf(key))
    .find((index) => index !== -1);

  if (stepWasWithdrawn !== undefined) return stepWasWithdrawn;

  return Math.min(previousIndex, lastIndex);
}

export function resolveStepIndex(
  key: KioskStepKey,
  currentIndex: number,
  previousStepKeys: readonly KioskStepKey[],
  nextStepKeys: readonly KioskStepKey[]
): number {
  const target = nextStepKeys.indexOf(key);
  if (target !== -1) return target;

  return reconcileStepIndex(currentIndex, previousStepKeys, nextStepKeys);
}
